import { Language } from '../translations'

export const certificateTranslations: Record<string, Record<Language, string>> = {
  certificateUpdated: {
    en: 'Certificate updated successfully',
    fi: 'Sertifikaatti päivitetty onnistuneesti'
  },
  certificateDeleted: {
    en: 'Certificate deleted successfully',
    fi: 'Sertifikaatti poistettu onnistuneesti'
  },
  certificateName: {
    en: 'Certificate Name',
    fi: 'Sertifikaatin nimi'
  },
  certificateNamePlaceholder: {
    en: 'Enter certificate name',
    fi: 'Syötä sertifikaatin nimi'
  },
  issuerPlaceholder: {
    en: 'Enter issuing organization',
    fi: 'Syötä myöntävä organisaatio'
  },
  issueDate: {
    en: 'Issue Date',
    fi: 'Myöntämispäivä'
  },
  expiryDate: {
    en: 'Expiry Date',
    fi: 'Voimassaolon päättymispäivä'
  },
  certificateRequiredFields: {
    en: 'Name, issuing organization, and issue date are required.',
    fi: 'Nimi, myöntävä organisaatio ja myöntämispäivämäärä ovat pakollisia.'
  },
  addCertificate: {
    en: 'Add Certificate',
    fi: 'Lisää sertifikaatti'
  },
  editCertificate: {
    en: 'Edit Certificate',
    fi: 'Muokkaa sertifikaattia'
  },
  name: {
    en: 'Name',
    fi: 'Nimi'
  },
  issuer: {
    en: 'Issuing Organization',
    fi: 'Myöntävä organisaatio'
  },
  issue_date: {
    en: 'Aquired',
    fi: 'Saatu'
  },
  expiry_date: {
    en: 'Valid until',
    fi: 'Voimassa asti'
  },
  issueDateRequired: {
    en: 'Issue date is required',
    fi: 'Myöntämispäivämäärä on pakollinen'
  },
  noCertificates: {
    en: 'No certificates',
    fi: 'Ei sertifikaatteja'
  },
  certificateAddSuccess: {
    en: 'Certificate added successfully!',
    fi: 'Sertifikaatti lisätty onnistuneesti!'
  },
  certificateUpdateSuccess: {
    en: 'Certificate updated successfully!',
    fi: 'Sertifikaatti päivitetty onnistuneesti!'
  },
  certificateDeleteSuccess: {
    en: 'Certificate deleted successfully!',
    fi: 'Sertifikaatti poistettu onnistuneesti!'
  },
  confirmDeleteCertificate: { en: "Are you sure you want to delete this certificate?", fi: "Haluatko varmasti poistaa tämän sertifikaatin?" },
  credlyUrl: {
    en: 'Credly URL',
    fi: 'Credly-linkki'
  },
  credlyUrlPlaceholder: {
    en: 'Enter Credly badge URL (optional)',
    fi: 'Syötä Credly-merkin URL (valinnainen)'
  },
  viewBadge: {
    en: 'View Badge',
    fi: 'Näytä merkki'
  },
  invalidCredlyUrl: {
    en: 'Please enter a valid Credly badge URL',
    fi: 'Syötä kelvollinen Credly-merkin URL'
  }
};
